module.exports = __webpack_public_path__ + "media/images/png/1-79eabb89f729943ab2ba26528bcf28c0.png";